/***********************************************
ICEMEDX - Developed By ICEMEDX, Inc.
Copyright 2012 ICEMEDX, Inc.
***********************************************/
import { Injectable } from '@angular/core';
import { IceEntity } from '../core/IceEntity';
import { IceTypes } from '../icetypes';
import { subscriptionobject } from './subscription';

export class orderdetailobject extends IceEntity {
  order_detail_id: number = 0;
  order_detail_key: string = "";
  trans_account: string = "";
  account_type: IceTypes.ACCOUNT_TYPE = IceTypes.ACCOUNT_TYPE.actNone;
  quantity: number = 0.0;
  price: number = 0.0;
  currency_rate: number = 0.0;
  currency_price: number = 0.0;
  subscription_key: string = "";
  summary: string = "";

  SUBSCRIPTOBJ: subscriptionobject[] = [];

  gettablename(): string {
    return "ORDER_DETAIL";
  }

  hassubtree(ColumnName: string): boolean {
    if (ColumnName.length == 0) return false;
    else if (ColumnName == "SUBSCRIPTOBJ") return true;

    return false;
  }

  getsubtreetablename(ColumnName: string): string {
    if (ColumnName.length == 0) return null;
    else if (ColumnName == "SUBSCRIPTOBJ") return "SUBSCRIPTION";

    return null;
  }
}
